import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'shards-react';
import { usePaymentDocuments } from '../../../hooks/queries/usePaymentDocuments';

const Documents = ({ parsedDocumentExtId, scrapedDocumentExtId }) => {
  const { documents, loading, error } = usePaymentDocuments(
    parsedDocumentExtId,
    scrapedDocumentExtId
  );

  if (error) return <Alert theme="danger">No se pudieron cargar los documentos.</Alert>;
  if (loading) return null;

  return (
    <ul>
      {!documents.length ? (
        <span>No se encontraron documentos parseados, posiblemente es una liquidación migrada</span>
      ) : (
        documents.map((document) => (
          <li key={document.link}>
            <a href={document.link}>{`${document.show}: ${document.linkKey}`}</a>
          </li>
        ))
      )}
    </ul>
  );
};

Documents.propTypes = {
  parsedDocumentExtId: PropTypes.string,
  scrapedDocumentExtId: PropTypes.string
};

export default Documents;
